import { Button } from 'antd';
import styled from 'styled-components';

const AppButton = styled(Button)`
  border-radius: ${({ $borderRadius = '4px' }) => $borderRadius};
  font-family: Inter, sans-serif;
  font-weight: ${({ $fontWeight = '600' }) => $fontWeight};
  height: ${({ $height = '44px' }) => $height};
  padding: ${({ $padding = '0 16px' }) => $padding};
  gap: ${({ $gap = '8px' }) => $gap};
`;

export default AppButton;
